import {
  ADD_AUTH_USER_PROFILE_TO_LOCAL_STORAGE,
  FORGOT_PASSWORD_FAIL,
  FORGOT_PASSWORD_START,
  FORGOT_PASSWORD_SUCCESSFUL,
  GET_USER_PROFILE_FAIL,
  GET_USER_PROFILE_START,
  GET_USER_PROFILE_SUCCESSFUL,
  IDENTIFY_AUTH_EXIST_ON_DEVICE_FAIL,
  IDENTIFY_AUTH_EXIST_ON_DEVICE_START,
  IDENTIFY_AUTH_EXIST_ON_DEVICE_SUCCESSFUL,
  LOGIN_FAIL,
  LOGIN_START,
  LOGIN_SUCCESSFUL,
  LOGOUT_FAIL,
  LOGOUT_START,
  LOGOUT_SUCCESSFUL,
  UPDATE_USER_PROFILE_FAIL,
  UPDATE_USER_PROFILE_START,
  UPDATE_USER_PROFILE_SUCCESSFUL,
} from '../actionConstants';

export const loginStart = (payload: any = {}) => async (dispatch: any) =>
  dispatch({
    type: LOGIN_START,
    payload: payload,
  });

export const loginSuccessful = (payload: any = {}) => async (dispatch: any) =>
  dispatch({
    type: LOGIN_SUCCESSFUL,
    payload: payload,
  });

export const loginFail = (payload: any = {}) => async (dispatch: any) =>
  dispatch({
    type: LOGIN_FAIL,
    payload: payload,
  });

export const logoutStart = (payload: any = {}) => async (dispatch: any) => {
  dispatch({
    type: LOGOUT_START,
    payload: payload,
  });
  console.log(payload);
};

export const logoutSuccessful = (payload: any = {}) => async (dispatch: any) => {
  dispatch({
    type: LOGOUT_SUCCESSFUL,
    payload: payload,
  });
};

export const logoutFail = (payload: any = {}) => async (dispatch: any) => {
  dispatch({
    type: LOGOUT_FAIL,
    payload: payload,
  });
};

export const getUserProfileStart = (payload: any = {}) => async (dispatch: any) => {
  dispatch({
    type: GET_USER_PROFILE_START,
    payload: payload,
  });
};

export const getUserProfileSuccessful = (payload: any = {}) => async (dispatch: any) => {
  dispatch({
    type: GET_USER_PROFILE_SUCCESSFUL,
    payload: payload,
  });
};

export const getUserProfileFail = (payload: any = {}) => async (dispatch: any) => {
  dispatch({
    type: GET_USER_PROFILE_FAIL,
    payload: payload,
  });
};

export const identifyAuthExistOnDeviceStart = (payload: any = {}) => (dispatch: any) => {
  dispatch({
    type: IDENTIFY_AUTH_EXIST_ON_DEVICE_START,
    payload: payload,
  });
};

export const identifyAuthExistOnDeviceSuccessful = (payload: any = {}) => (dispatch: any) => {
  dispatch({
    type: IDENTIFY_AUTH_EXIST_ON_DEVICE_SUCCESSFUL,
    payload: payload,
  });
};

export const identifyAuthExistOnDeviceFail = (payload: any = {}) => (dispatch: any) => {
  dispatch({
    type: IDENTIFY_AUTH_EXIST_ON_DEVICE_FAIL,
    payload: payload,
  });
};

export const updateUserProfileStart = (payload: any = {}) => async (dispatch: any) => {
  dispatch({
    type: UPDATE_USER_PROFILE_START,
    payload: payload,
  });
};

export const updateUserProfileSuccessful = (payload: any) => async (dispatch: any) => {
  dispatch({
    type: UPDATE_USER_PROFILE_SUCCESSFUL,
    payload: payload,
  });
};

export const updateUserProfileFail = (payload: any) => async (dispatch: any) => {
  dispatch({
    type: UPDATE_USER_PROFILE_FAIL,
    payload: payload,
  });
};

export const addUserProfileToLocalStorage = (payload: any) => async (dispatch: any) => {
  dispatch({
    type: ADD_AUTH_USER_PROFILE_TO_LOCAL_STORAGE,
    payload: payload,
  });
};

export const forgotPasswordStart = (payload: any) => async (dispatch: any) =>
  dispatch({
    type: FORGOT_PASSWORD_START,
    payload: payload,
  });

export const forgotPasswordSuccessful = (payload: any) => async (dispatch: any) =>
  dispatch({
    type: FORGOT_PASSWORD_SUCCESSFUL,
    payload: payload,
  });

export const forgotPasswordFail = (payload: any) => async (dispatch: any) =>
  dispatch({
    type: FORGOT_PASSWORD_FAIL,
    payload: payload,
  });
